/**
 * Box domain event schemas — Upstash Box job handoff (Synaptic tier-3).
 *
 * @module box.events
 * @since 2026-05-25
 */

import { z } from 'zod'
import { BackboneEventSchema } from '../types/backbone.ts'

export const BoxJobRequestedPayloadSchema = z.object({
  principal_id: z.string().uuid(),
  run_id: z.string().uuid().optional(),
  session_id: z.string().optional(),
  user_id: z.string().uuid().optional(),
  org_id: z.string().uuid().nullable().optional(),
  command: z.string().min(1).optional(),
  workspace_path: z.string().optional(),
  target_scope: z.string().optional(),
  /** Max seconds the exec call may run before the connector reports a timeout. */
  timeout_seconds: z.number().int().positive().optional(),
})

export type BoxJobRequestedPayload = z.infer<typeof BoxJobRequestedPayloadSchema>

export const BoxJobCompletePayloadSchema = z.object({
  principal_id: z.string().uuid(),
  run_id: z.string().uuid().optional(),
  session_id: z.string().optional(),
  success: z.boolean(),
  output: z.string().optional(),
  error: z.string().optional(),
  box_id: z.string().uuid().optional(),
})

export type BoxJobCompletePayload = z.infer<typeof BoxJobCompletePayloadSchema>

export const BoxJobRequestedEvent = BackboneEventSchema.extend({
  domain: z.literal('box'),
  type: z.literal('job_requested'),
  payload: BoxJobRequestedPayloadSchema,
})

export const BoxJobCompleteEvent = BackboneEventSchema.extend({
  domain: z.literal('box'),
  type: z.literal('job_complete'),
  payload: BoxJobCompletePayloadSchema,
})

export const BoxDomainEvents = [
  BoxJobRequestedEvent,
  BoxJobCompleteEvent,
] as const
